export default __webpack_public_path__ + "static/media/install-chat-widget1.df5b8519.png";